import { defineElement, html, TemplateElement, unsafeHTML } from '@webtides/element-js';
import '../fragments/image-element.js';
import { decodeIfEscaped } from '@/services/content-service.js';
import { getId, getTemplate } from '@/mgnl/utils/magnolia.js';

class FallBack extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }
    injectProperties() {
        return { environment: null, mgnlContext: null };
    }

    template() {
        if (this.mgnlContext?.isMagnoliaEdit !== true) {
            return html`<span style="display: none;">${getId(this.content)}, ${getTemplate(this.content)}</span>`;
        }

        return html`
            <div class="py-6 px-8 border border-rounded">
                <h3>Fallback Component</h3>
                <pre>
                    ${JSON.stringify(this.content, null, 2)}
                </pre
                >
            </div>
        `;
    }
}

defineElement('magnolia-fallback-component', FallBack);
